<script setup lang="ts">
import { Button, Card } from "@/components/Ui";
import { onDashboard } from "@/helpers/events";

const { t } = useI18n();
</script>
<template>
  <Card :class="`${$style[`root`]}`">
    <div :class="$style.col">
      <div :class="[$style.title, $style[`title-${$i18n.locale}`]]">
        {{ t("block.moreFriendsMoreMoney.title") }}
      </div>
      <p :class="$style.subtitle">
        {{ t("block.moreFriendsMoreMoney.subtitle") }}
      </p>
      <Button
        :title="$t('btn.inviteFriends')"
        :class="$style.button"
        size="custom"
        @click="
          onDashboard('login_button_click', '/login', {
            'cta type': 'button',
            'cta location': 'Block: More friends, more money',
            'cta text': 'Invite friends',
          })
        "
      />
    </div>
    <div :class="$style.gridable">
      <div>
        <span>100%</span>
        <span :class="[$style.colDesc, $style[`colDesc-${$i18n.locale}`]]">{{ t("block.moreFriendsMoreMoney.gridTitle100") }}</span>
      </div>
      <div>
        <span>70%</span>
        <span :class="[$style.colDesc, $style[`colDesc-${$i18n.locale}`]]">{{ t("block.moreFriendsMoreMoney.gridTitle70") }}</span>
      </div>
      <div>
        <span>70%</span>
        <span :class="[$style.colDesc, $style[`colDesc-${$i18n.locale}`]]">{{ t("block.moreFriendsMoreMoney.gridTitle70") }}</span>
      </div>
      <div>
        <span>30%</span>
        <span :class="[$style.colDesc, $style[`colDesc-${$i18n.locale}`]]">{{ t("block.moreFriendsMoreMoney.gridTitle30") }}</span>
      </div>
      <div>
        <span>30%</span>
        <span :class="[$style.colDesc, $style[`colDesc-${$i18n.locale}`]]">{{ t("block.moreFriendsMoreMoney.gridTitle30") }}</span>
      </div>
      <div>
        <span>30%</span>
        <span :class="[$style.colDesc, $style[`colDesc-${$i18n.locale}`]]">{{ t("block.moreFriendsMoreMoney.gridTitle30") }}</span>
      </div>
    </div>
  </Card>
</template>

<style lang="scss" module>
.root {
  @apply rounded-[32px] relative grid grid-cols-1 lg:grid-cols-2 gap-x-5 gap-y-10 w-full overflow-hidden;
  @apply p-8;
  @apply min-h-[500px] xxs:min-h-[530px] md:min-h-[268px] lg:min-h-[426px];
  @apply bg-accent-base text-white;
}

.col {
  @apply flex flex-col gap-7 items-center text-center lg:items-start lg:text-left;
}

.title {
  @apply font-black leading-none rtl:text-right;
  @apply text-[56px] xs:text-[70px];
  &-en,
&-id,
&-da,
&-et,
&-hu,
&-lt,
&-nb,
&-ro,
&-sl,
&-cs,
&-el,
&-fi,
&-lv,
&-nl,
&-sk,
&-sv,
&-he,
  &-be,
  &-de,
  &-it,
  &-pt,
  &-tr,
  &-ua,
  &-es,
  &-fr,
  &-ja,
  &-ru,
  &-zh,
  &-th,
  &-hi,
  &-ar,
  &-bn,
  &-ko,
  &-vi,
  &-sw{
    @apply text-[56px] xs:text-[70px];
  }
  &-pl {
    @apply text-[48px] xxs:text-[52px] xs:text-[64px] md:text-[70px];
  }
  &-bg {
    @apply text-[48px] xxs:text-[52px] xs:text-[70px];
  }
  &-zh {
    @apply leading-[1.2];
  }
  &-ja {
    @apply leading-[1.2];
  }
}

.subtitle {
  @apply text-xl rtl:text-right;
}

.button {
  @apply text-[20px] py-[18px] w-full md:max-w-[300px] mt-auto;
}

.gridable {
  @apply grid grid-cols-6 gap-3;
  & > div {
    @apply flex flex-col gap-1 rounded-[20px] px-5 py-3;

    &:first-child {
      @apply col-span-6 bg-white bg-opacity-[0.36];

      & span:first-child {
        @apply text-[52px];
      }
    }


    &:nth-child(2), &:nth-child(3) {
      @apply col-span-6 xs:col-span-3 bg-white bg-opacity-[0.24];

      & span:first-child {
        @apply text-[40px];
      }
    }

    &:nth-child(n+4) {
      @apply col-span-6 xs:col-span-2 bg-white bg-opacity-[0.12];

      & span:first-child {
        @apply text-[32px] xs:text-[30px] md:text-[32px];
      }
    }

    &:nth-child(3), &:nth-child(4), &:nth-child(5) {
      @apply hidden xs:flex;
    }
  }


  & span {
    &:first-child {
      @apply font-black;
    }
  }
}
.colDesc {
  @apply text-[15px] xs:text-[13px] md:text-[15px];
  &-en,
&-id,
&-da,
&-et,
&-hu,
&-lt,
&-nb,
&-ro,
&-sl,
&-cs,
&-el,
&-fi,
&-lv,
&-nl,
&-sk,
&-sv,
&-he,
  &-be,
  &-de,
  &-it,
  &-pt,
  &-th,
  &-hi,
  &-ua,
  &-es,
  &-fr,
  &-ja,
  &-ru,
  &-bg,
  &-ja {
    @apply text-[15px] xs:text-[13px] md:text-[15px];
  }
  &-tr {
    @apply text-[15px] xs:text-[10px] md:text-[15px];
  }
}
</style>